import { render, staticRenderFns } from "./GroupLists.vue?vue&type=template&id=5576e781&scoped=true&"
import script from "./GroupLists.vue?vue&type=script&lang=js&"
export * from "./GroupLists.vue?vue&type=script&lang=js&"
import style0 from "./GroupLists.vue?vue&type=style&index=0&id=5576e781&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5576e781",
  null
  
)

export default component.exports